export default __webpack_public_path__ + "static/media/onepass-logo-ENG.15bf7aaa.jpg";